// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyMobileCta_root__tr2kx","button":"StickyMobileCta_button__fZEgA"};